// extracted by mini-css-extract-plugin
export default {"belongStandards":"belongStandards-f3fc","gradientBorder":"gradientBorder-20b4","title":"title-a241"};